import { Calendar, ChevronRight, Star, Trophy, Users } from "lucide-react"
import { Link } from "react-router-dom"

const featureItems = [
  {
    title: "Torneos Oficiales",
    description: "Compite en eventos validados con resultados y rankings confiables.",
    icon: Trophy,
    accent: "from-amber-500/20 via-amber-400/5 to-transparent",
    iconBg: "bg-amber-100 dark:bg-amber-900/30",
    iconColor: "text-amber-600 dark:text-amber-400",
    href: "/tournaments",
    cta: "Ver torneos",
  },
  {
    title: "Comunidad Activa",
    description: "Conecta con jugadores, organizadores y tiendas de todo Chile.",
    icon: Users,
    accent: "from-cyan-500/20 via-cyan-400/5 to-transparent",
    iconBg: "bg-cyan-100 dark:bg-cyan-900/30",
    iconColor: "text-cyan-600 dark:text-cyan-400",
    href: "/stores",
    cta: "Ver tiendas",
  },
  {
    title: "Calendario Vivo",
    description: "Encuentra rápidamente próximos torneos por juego y temporada.",
    icon: Calendar,
    accent: "from-rose-500/20 via-rose-400/5 to-transparent",
    iconBg: "bg-rose-100 dark:bg-rose-900/30",
    iconColor: "text-rose-600 dark:text-rose-400",
    href: "/tournaments",
    cta: "Ver calendario",
  },
  {
    title: "Rankings y Estadísticas",
    description: "Sigue tu progreso, posición y rendimiento en cada temporada.",
    icon: Star,
    accent: "from-violet-500/20 via-violet-400/5 to-transparent",
    iconBg: "bg-violet-100 dark:bg-violet-900/30",
    iconColor: "text-violet-600 dark:text-violet-400",
    href: "/ranking",
    cta: "Ver ranking",
  },
]

export const FeaturesSection = () => {
  return (
    <section className="px-4 py-14">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-10 text-center">
          <h2 className="text-3xl font-bold md:text-4xl">¿Por qué elegir MyL?</h2>
          <p className="mt-2 text-lg text-muted-foreground">
            Diseñado para competir con orden, velocidad y transparencia.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item) => {
            const Icon = item.icon
            return (
              <Link
                key={item.title}
                to={item.href}
                className="group relative overflow-hidden rounded-xl border border-border/60 bg-card/70 shadow-sm backdrop-blur-sm transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 flex flex-col"
              >
                <div
                  className={`pointer-events-none absolute inset-0 bg-gradient-to-br ${item.accent}`}
                />

                <div className="relative flex flex-col gap-3 p-5 flex-1">
                  <div
                    className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${item.iconBg} transition-transform duration-200 group-hover:scale-110`}
                  >
                    <Icon className={`h-5 w-5 ${item.iconColor}`} />
                  </div>

                  <div className="flex-1">
                    <h3 className="font-semibold text-sm leading-tight mb-1">{item.title}</h3>
                    <p className="text-xs text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  <div
                    className={`flex items-center gap-1 text-xs font-medium ${item.iconColor} mt-1`}
                  >
                    {item.cta}
                    <ChevronRight className="h-3.5 w-3.5 transition-transform duration-150 group-hover:translate-x-0.5" />
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}
